import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { AddItemsToContainer, IShipmentItem, logisticsActionCreators, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { IUnallocatedProduct, unallocatedProductsActionCreators } from '../../unallocatedProducts';

function* addItemsToContainerSaga(action: AddItemsToContainer) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeAdd, action.payload.shipmentContainerId, action.payload.unallocatedProducts);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.setShipmentItems(response.value.value));
      yield put(unallocatedProductsActionCreators.remove(response.value.value.map(x => x.inventTransId)));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAddItemsToContainer() {
  yield takeEvery(LogisticsActionKeys.ADD_ITEMS_TO_CONTAINER, addItemsToContainerSaga);
}

async function executeAdd(
  shipmentContainerId: number,
  unallocatedProducts: IUnallocatedProduct[]
): Promise<IApiExecuteRespone<IEntityWithMessages<IShipmentItem[]>>> {
  return executeApiRequest(() =>
    httpService.post(`${ApiUrls.shipment()}/Containers/${shipmentContainerId}/Items`, unallocatedProducts)
  );
}
